import script from "./RefiLoanConfigurationDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefiLoanConfigurationDetails.vue?vue&type=script&setup=true&lang=ts"

import "./RefiLoanConfigurationDetails.vue?vue&type=style&index=0&id=4f5796e9&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5796e9"]])

export default __exports__